export default {
  'filter.field.role': '角色',
  'filter.field.department': '部门',
  'filter.field.employee': '员工',
  'filter.field.order_source': '订单来源',
  'filter.field.service_type': '服务类型',
  'filter.field.view_dimension': '查看维度',

  'filter.placeholder.role': '按角色筛选',
  'filter.placeholder.departments': '按部门筛选',
  'filter.placeholder.employee': '按员工筛选',
  'filter.placeholder.order_source': '按订单来源筛选',
  'filter.placeholder.service_type': '按服务类型筛选',
};
